import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';

import FavoritesButton from 'components/FavoritesButton';

import { favoriteOperations, favoriteSelectors } from 'ducks/favorites';

const FavoritesButtonContainer = ({ title, entityType, entityId, type }) => {
	const dispatch = useDispatch();
	const [, setCookie] = useCookies(['favorite']);

	const data = useMemo(() => {
		let entityData = { entityType, entityId };

		if (type) {
			entityData = { ...entityData, type };
		}
		return entityData;
	}, [entityType, entityId, type]);

	const isFavorite = useSelector(
		favoriteSelectors.selectIsFavorite({ entityType, _id: entityId })
	);

	const onClick = useCallback(() => {
		if (isFavorite) {
			dispatch(favoriteOperations.removeFavorites(data));
		} else {
			dispatch(favoriteOperations.addFavorites(data));
		}
	}, [isFavorite, data]);

	const onAuthorizationRequest = useCallback(() => {
		setCookie('favorite', { ...data, title }, { path: '/' });
	}, [data, title]);

	return (
		<FavoritesButton
			isFavorite={isFavorite}
			onClick={onClick}
			onAuthorizationRequest={onAuthorizationRequest}
		/>
	);
};

FavoritesButtonContainer.propTypes = {
	title: PropTypes.string.isRequired,
	entityType: PropTypes.string.isRequired,
	entityId: PropTypes.number.isRequired,
	type: PropTypes.string
};

export default FavoritesButtonContainer;
